import { ShieldAlert, Hand, PhoneOff, ExternalLink, DoorClosed, Users, ArrowRight, Phone } from 'lucide-react';
import { tips, siteConfig } from '../data';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

// Log icons to diagnose which one is undefined
console.log("TipsSection Icons:", { ShieldAlert, Hand, PhoneOff, ExternalLink, DoorClosed, Users, ArrowRight, Phone });

const iconMap = {
  ShieldAlert: ShieldAlert,
  Hand: Hand,
  PhoneOff: PhoneOff,
  ExternalLink: ExternalLink,
  DoorClosed: DoorClosed,
  Users: Users,
};

export default function TipsSection() {
  return (
    <section className="pt-16 pb-0 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start mb-20">
          
          {/* Venstre kolonne: Overskrift og beskrivelse */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-5 lg:sticky lg:top-24 text-left"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-[#103B66] mb-4">
              6 gode råd til en tryggere hverdag
            </h2>
            <p className="text-lg text-slate-600 pb-8 border-b border-slate-200">
              Små forholdsregler der gør en stor forskel for din sikkerhed online og i hjemmet.
            </p>
          </motion.div>

          {/* Højre kolonne: De 6 gode råd */}
          <div className="lg:col-span-7 space-y-6">
            {tips.map((tip, index) => {
              // Safe fallback to ShieldAlert, Phone or a generic element if the icon is undefined
              const Icon = iconMap[tip.icon] || ShieldAlert || Phone;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="flex flex-col border-b border-slate-100 pb-5 last:border-0 last:pb-0"
                >
                  <div className="text-black mb-4">
                    {Icon ? (
                      <Icon className="w-12 h-12" />
                    ) : (
                      <div className="w-12 h-12 bg-slate-200 rounded-none flex items-center justify-center">
                        <span className="text-xl">🛡️</span>
                      </div>
                    )}
                  </div>
                  <h3 className="text-xl font-bold text-[#103B66] mb-2">{tip.title}</h3>
                  {(() => {
                    const linkMap = {
                      "Del aldrig dine private koder!": "/vidensbank/del-aldrig-dine-private-koder",
                      "Udlever aldrig dine personlige ejendele!": "/vidensbank/86-aarig-tog-fusen-paa-falske-bankmaend",
                      "Tag ikke telefonen fra et nummer du ikke kender!": "/vidensbank/tag-ikke-telefonen-fra-et-nummer-du-ikke-kender",
                      "Tryk ikke på links du ikke har tiltro til!": "/vidensbank/undgaa-falske-sms-er-smishing-saadan-gennemskuer-du-dem",
                      "Lad være med at åbne døren for nogen du ikke kender!": "/vidensbank/86-aarig-tog-fusen-paa-falske-bankmaend",
                      "Aftal et ord med dine pårørende eller os!": "/vidensbank/aftal-et-ord-med-dine-paaroerende-eller-os"
                    };
                    const targetUrl = linkMap[tip.title] || "/vidensbank";
                    return (
                      <Link 
                        to={targetUrl} 
                        className="text-sm font-bold text-[#103B66] hover:text-blue-800 inline-flex items-center gap-1 mt-1 transition-colors w-fit"
                      >
                        gå til vidensbank <ArrowRight className="w-4 h-4" />
                      </Link>
                    );
                  })()}
                </motion.div>
              );
            })}
          </div>

        </div>
      </div>

      <div className="bg-[#103B66] py-16 md:py-20 text-center text-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">Er du i tvivl om noget online?</h3>
          <p className="text-slate-100 text-lg mb-8 max-w-xl mx-auto">
            Vi sidder klar til at hjælpe dig med at gennemskue mistænkelige henvendelser.
          </p>
          <a
            href={`tel:${siteConfig.phone.replace(/\s/g, '')}`}
            className="inline-flex items-center px-6 py-3 bg-white text-[#103B66] font-bold hover:bg-slate-50 transition-all gap-2"
          >
            <Phone className="w-5 h-5" fill="currentColor" />
            71 74 27 17
          </a>
        </div>
        {/* Decorative background */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 translate-y-1/2 -translate-x-1/2"></div>
      </div>
    </section>
  );
}
